import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout" }

import { ref, watch, onMounted } from "vue";
import { Ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { VerticalLayout } from "../../VerticalLayout/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();

const percentage: Ref<number> = ref(0);
const isProgress: Ref<boolean> = ref(false);

watch(route, () => {
  progress();
});

const fetchMe = async () => {
  try {
    await store.dispatch("auth/getMe");
    const roles: string[] = (store.state as any).auth?.roles || [];
    if (roles.length === 0) {
      router.push({ name: "403" });
    }
  } catch (e) {
    console.error(e);
    router.push({ name: "403" });
  }
};

onMounted(() => {
  progress();
  if (route.name === "403" || route.name === "404") return;
  fetchMe();
});

const progress = () => {
  percentage.value = 0;
  isProgress.value = true;
  const interval = setInterval(() => {
    percentage.value = (percentage.value % 100) + 10;
    if (percentage.value === 100) {
      clearInterval(interval);
      setTimeout(() => {
        isProgress.value = false;
      }, 500);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_progress = _resolveComponent("el-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isProgress.value)
      ? (_openBlock(), _createBlock(_component_el_progress, {
          key: 0,
          percentage: percentage.value,
          "show-text": false,
          class: "layout__progress"
        }, null, 8, ["percentage"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VerticalLayout), { class: "layout_vertical" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ]))
}
}

})